var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.74,
    height: 32.74,
    viewBox: "0 0 32.74 32.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_help_2161200",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M32.749,15.768V30.789a1.946,1.946,0,0,1-1.94,1.94H15.339C7,32.73.01,24.568.01,16.36A16.371,16.371,0,0,1,16.38-.01c8.455,0,16.37,7.1,16.37,15.778ZM15.177,20.842h2.4v-2.3c0-3.088,4.291-1.858,4.291-6.45,0-6.716-10.987-6.768-10.987.628h2.487c.056-4.136,6.013-4.25,6.013-.6,0,3.526-4.209,2.132-4.209,6.4v2.323Zm-.328,5.439h3.143v-3.2H14.849Z",
    transform: "translate(-0.01 0.01)",
    fill: "#f68e3f",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.8f121f19e90d8b4af565d2ce50ccab0e.svg";
export { ForwardRef as ReactComponent };